import { Capacity } from "./capacity.model";
import { Offer } from "./offer.model";
import { ProviderDatacenterCompanyPool } from "./providerDatacenterCompanyPool.model";
import { Rental } from "./rental.model";
import { SoftwareInstance } from "./software-instance.model";
import { ClassOrString, Parameter, Verylys } from "./verylys";

export enum SERVICE_INSTANCE_INSTALL_STATUS {

}

export interface ServiceInstance extends Verylys {
    _id: string;
    friendly_id: string;
    parameters: {
        install_status: Parameter<SERVICE_INSTANCE_INSTALL_STATUS>;
        custom_name: Parameter<string>;
    }

    rental: ClassOrString<Rental>;
    offer: ClassOrString<Offer>;
    software_instances: ClassOrString<SoftwareInstance>[];
    provider_datacenter_company_pool: ClassOrString<ProviderDatacenterCompanyPool>;
    capacities: Capacity[];
}